
import layerEvents from "../utils/layerEvents";
import atlasApi from "../utils/atlasapi";
import TurfBBox from '@turf/bbox';
import Workmode from "../classes/Workmode";
import wmConfig from "../data/wmConfig";
import Country from "../classes/Country";
import {formatArea} from "../utils/functions";
import {Dropdown, Button, Row, Col } from "react-bootstrap";

import { Eye, EyeSlash, PencilLine, Plus, DotsThreeVertical, Book, Crosshair, CircleNotch, Danger, Warning, Palette, Pentagon, Info, Building, Polygon   } from "@phosphor-icons/react";

class WorkmodeAll extends Workmode{

	lastUnknownHoveredId = null;
	lastKnownHoveredId = null;
	selectedPlots = [];
	selectedKnownPlots = [];
	hoveredPlots = [];
	updatedPlots = [];
	hiddenPlots = [];
	defaultListSort = {
		"column": "fullName", 
		"direction":"asc"
	};
	
	map = null;
	refresh = null;
	setOwner = null;
	setLand = null;
	scenario = null;
	
	constructor() {
		super();

	}
	
	getData(map){
		var known = map.queryRenderedFeatures({layers: ['cadastral-known-fill']});
		var unknown = map.queryRenderedFeatures({layers: ['cadastral-unknown-fill-line']});
		var unique = []
		var processed = [];
		if(this.reload){
			return this.data;
		}
		
		//prevent querying features when zoom level too low
		if(map.getZoom() > 12){


				//for known plots first
			known.forEach((f)=>{

				var id = f.properties.propertyid;
				if(id && processed.indexOf(id) == -1){
					f.properties.fullName = f.properties.company_name && f.properties.company_name.length ? f.properties.company_name : f.properties.first_name+' '+f.properties.last_name;
					f.properties.id = id;
					f.properties.unknown = false;
					f.properties.vindrid = f.properties.propertyid;
					unique.push(f.properties);
					processed.push(id);
				}

			});

				//for unknown plots
			unknown.forEach((f)=>{

				var id = f.properties.vindrid;
				if(id && processed.indexOf(id) == -1){
					f.properties.id = id;
					f.properties.fullName = "(Unknown)";
					f.properties.unknown = true;
					unique.push(f.properties);
					processed.push(id);
				}

			});
		}
		this.data = unique;
		return this.data;
		
	}
	isHoveredBy(id){
		if(!this.lastKnownHoveredId && !this.lastUnknownHoveredId)
			return false;
		return id == this.lastKnownHoveredId || id == this.lastUnknownHoveredId;
	}
	
	handleZoomEnd = (e)=>{
		delete this.reload;
		this.getData(this.map);
		this.refresh(Math.random());
	}
	handleKnownHover = (e)=>{
		const feature = e.features[0];
		if(!feature || feature.properties.propertyid == this.lastKnownHoveredId)
			return false;
		
		this.lastKnownHoveredId = feature.properties.propertyid;

		
		this.cancelDelay();
		this.delayScroll = setTimeout(()=>{
			var elem = document.getElementById("row-"+this.lastKnownHoveredId);
			if(elem)
				elem.scrollIntoView({ behavior: "smooth"});
		},1000);
			
			
		this.setUnknownFillPaint();
		this.setKnownFillPaint();
		this.refresh(Math.random());
	}
	handleKnownLeave = (e)=>{
		
		this.lastKnownHoveredId = null;
		this.setUnknownFillPaint();
		this.setKnownFillPaint();
		this.cancelDelay();
		this.refresh(Math.random());
    }
	
	handleUnknownLeave = (e)=>{
		
		this.lastUnknownHoveredId = null;
		
		this.cancelDelay();
		this.setUnknownFillPaint();
		this.setKnownFillPaint();

		this.refresh(Math.random());
    }
	cancelDelay = ()=>{
		if(this.delayScroll){
			clearTimeout(this.delayScroll);
		}	
	}
	highlightResults(items){
		
		this.selectedKnownPlots = [];
		this.selectedPlots = [];
		
		items.forEach((i)=>{
			if(i.propertyid)
				this.selectedKnownPlots.push(i.propertyid);
			else
				this.selectedPlots.push(i.vindrid);
		});
		
		
		this.setUnknownFillPaint();
		this.setKnownFillPaint();
	}
	handleUnknownHover = (e)=>{

		const feature = e.features[0];
		
		if(!feature || feature.properties.vindrid == this.lastUnknownHoveredId)
			return false;
		
		//check if hovering known land and prevent highligh of the unknown layer with same id
		if(feature.properties.vindrid ==  this.lastKnownHoveredId)
			this.lastUnknownHoveredId = null;
		else{
			this.lastUnknownHoveredId = feature.properties.vindrid;
			
			this.cancelDelay();
			this.delayScroll = setTimeout(()=>{
				var elem = document.getElementById("row-"+this.lastUnknownHoveredId);
				if(elem)
					elem.scrollIntoView({ behavior: "smooth"});
			},1000);
		}
		
		this.setUnknownFillPaint();
		this.setKnownFillPaint();
		this.refresh(Math.random());
		
	}
	handleKnownClick = (e) => {
		
		e.originalEvent.stopPropagation();
		var plot = structuredClone(e.features[0]);
		
		var unknownFeatures = this.map.queryRenderedFeatures(e.point, {layers: ['cadastral-unknown-fill']});

		//deselect if click the same plot
		if(this.selectedKnownPlots.length && this.selectedKnownPlots[0] == plot.properties.propertyid) {
			this.setLand(null);
			this.selectedKnownPlots = [];
			return;
		}
		
		this.selectedKnownPlots = [plot.properties.propertyid];
		this.selectedPlots = [];
		
		plot.vindrid = plot.propertyid;
		plot.properties.ownerid = e.features.map((o)=>{return this.sanitizeOwner(o.properties)});
		
		if(unknownFeatures)
			plot.properties.totalarea = unknownFeatures[0].properties.totalarea;
		
		this.setLand(this.sanitizePlot(plot));

	
		this.setUnknownFillPaint();
		this.setKnownFillPaint();
	}
	handleUnknownClick = (e) => {
		
		//if there is a known feature in the point do nothing
		var pointFeatures = this.map.queryRenderedFeatures(e.point);
		if(pointFeatures.findIndex((f)=>{return f.layer.id == 'cadastral-known-fill'}) != -1)
			return false;
		//

		var plot = e.features[0];
		
		
		//get all plots with the same vindrid
		
		
		if(this.selectedPlots.length && this.selectedPlots[0] == plot.properties.vindrid) {
			this.setLand(null);
			this.selectedPlots = [];
			return;
		}
		
		this.selectedPlots = [plot.properties.vindrid];
		this.selectedKnownPlots = []
		
		var idx = -1;
		
		if((idx = this.scenario.properties.features.findIndex((a)=>{return a.properties.vindrid == plot.properties.vindrid})) != -1)
			this.setLand(this.scenario.properties.features[idx]); //the properti was already fetched and added to the scenario
		else
			this.setLand(this.sanitizePlot(plot));

	
		this.setUnknownFillPaint();
		this.setKnownFillPaint();
	}
	handleListHover(plot){
		
		if(plot.landownerid){
			this.lastKnownHoveredId = plot.propertyid;
			this.setKnownFillPaint();
		}
		else {
			this.lastUnknownHoveredId = plot.vindrid;
			this.setUnknownFillPaint();
		}
		
		//this.refresh(Math.random());
	}
	handleListClick(plot){
		
		if(plot.landownerid){
			
			const lw = this.scenario.landowners.find((o)=>{return o.id == plot.landownerid});
			if(lw)
				this.setOwner(lw);
			else
				this.setOwner(plot);
		}
		else {
			this.setLand({properties:plot});
		}
		
	}
	handleListLeave(plot){
		this.lastKnownHoveredId = null;
		this.lastUnknownHoveredId = null;
		
		this.setUnknownFillPaint();
		this.setKnownFillPaint()
		//this.refresh(Math.random());
	}
	handleZoomToFit(item){
		
		atlasApi.getPropertyBB(item.vindrid ?? item.propertyid).then((results)=>{
			if(results && results.geometry){
				
				this.map.fitBounds(TurfBBox(results.geometry));
			}
			
		});
		
	}

	refreshMap(newScenario, newLand){
		this.reloadLayers();
		if(newLand)
			this.selectedKnownPlots = [newLand.properties.vindrid];
		this.selectedUnknownPlots = [];

		this.setUnknownFillPaint();
		this.setKnownFillPaint();
		if(newLand)
			this.setFetched(newLand.id);
		if(newScenario)
			this.scenario = newScenario;
	}
	setFetched(id){
		this.map.setFeatureState(
			{ source: 'cadastral-all', sourceLayer:'cadastral_'+this.countryCode, id: id },
			{ fetched: true }
		);		
	}
	
	setColor(id, color){
		
		var features = this.map.queryRenderedFeatures({layers: ['cadastral-unknown-fill']}).filter((f)=>{return f.properties.vindrid == id});
		
		features.forEach((f)=>{
			this.map.setFeatureState(
				{ source: 'cadastral-all', sourceLayer:f.sourceLayer, id: f.id },
				{ color: color }
			);	
		})
	}
	unsetColor(id){
		
		var features1 = this.map.queryRenderedFeatures({layers: ['cadastral-unknown-fill']}).filter((f)=>{return f.properties.vindrid == id});
		
		features1.forEach((f)=>{
			this.map.removeFeatureState(
				{ source: 'cadastral-all', sourceLayer:f.sourceLayer, id: f.id },
				'color'
			);	
		})
		
		var features2 = this.map.queryRenderedFeatures({layers: ['cadastral-known-fill', 'cadastral-known-fill-line']}).filter((f)=>{return f.properties.propertyid == id});
		
		features2.forEach((f)=>{
			this.map.setFeatureState(
				{ source: 'cadastral-all', sourceLayer:f.sourceLayer, id: f.id },
				{ 'removecolor': true }
			);	
		})
		
	}
	clear(){
		
		this.lastKnownHoveredId = null;
		this.lastUnknownHoveredId = null;
		this.selectedPlots = [];
		this.selectedKnownPlots = [];
		this.setUnknownFillPaint();
		this.setKnownFillPaint();
		
		this.refresh(Math.random());
	}
	
	reloadLayers = ()=>{
		
		//infoLayerPanel is set in infolayers.handleworkmode
		setTimeout(()=>{
			this.infoLayerPanel.clearWorkMode();

			var wm = wmConfig.get("", this.getCountry());

			this.infoLayerPanel.showWorkMode(wm);
		},500);
		
		this.reload = true;
		
		//
		
	}
	sanitizePlot(plot){
		plot.properties.vindrid		= plot.properties.vindrid ?? plot.properties.propertyid;
		plot.properties.fullName	= plot.properties.company_name ? plot.properties.company_name : plot.properties.first_name+' '+plot.properties.last_name;
		plot.properties.firstName	= plot.properties.firstName ?? plot.properties.first_name;
		plot.properties.lastName	= plot.properties.lastName ?? plot.properties.last_name;
		plot.properties.companyName	= plot.properties.companyName ?? plot.properties.company_name;
		plot.properties.id			= plot.properties.id ?? plot.properties.landownerid;
		
		delete plot.properties.propertyid;
		
		return plot;
	}
	sanitizeOwner(owner){
		
		owner.fullName		= owner.company_name	? owner.company_name : owner.first_name+' '+owner.last_name;
		owner.firstName		= owner.firstName		?? owner.first_name;
		owner.lastName		= owner.lastName		?? owner.last_name;
		owner.companyName	= owner.companyName		?? owner.company_name;
		owner.id			= owner.landownerid		?? owner.id;
		
		return owner;
	}
	toggleVisibilityAll(e, items){
		var invisible = e.target.classList.contains("opacity-25");
		this.hiddenPlots = [];
		if(!invisible){
			items.forEach((p)=>{
				if(p.propertyid)
					this.hiddenPlots.push(p.propertyid);
			});
		}
		e.target.classList.toggle("opacity-25");
		this.setKnownFillPaint();
		this.refresh(Math.random());
	}
	visibilityIcon(row){
		
		if(!row.color)
			return <EyeSlash size={16} />
		
		
		return <Eye size={16} onClick={(e)=>{this.toggleVisibilityAll(e, [row])}} id={"owner_"+row.id} data-id={row.id} className={ this.hiddenPlots.includes(row.propertyid) ? 'opacity-25' : ''} />
	}
	exitWorkmode(){

		this.unsetEvents();
	}
	setEvents(){
		
		this.map.on('zoomend', this.handleZoomEnd);
		this.map.on('dragend', this.handleZoomEnd);
		
		this.map.on('mousemove', 'cadastral-known-fill', this.handleKnownHover);
		this.map.on('mouseleave', 'cadastral-known-fill', this.handleKnownLeave);
		
		this.map.on('mousemove', 'cadastral-unknown-fill', this.handleUnknownHover);
		this.map.on('mouseleave', 'cadastral-unknown-fill', this.handleUnknownLeave);
		
		this.map.on('click', 'cadastral-known-fill', this.handleKnownClick);
		this.map.on('click', 'cadastral-unknown-fill', this.handleUnknownClick);

	}
	unsetEvents(){
		
		this.map.off('zoomend', this.handleZoomEnd);
		this.map.off('dragend', this.handleZoomEnd);
		
		this.map.off('mousemove', 'cadastral-known-fill', this.handleKnownHover);
		this.map.off('mouseleave', 'cadastral-known-fill', this.handleKnownLeave);
		
		this.map.off('mousemove', 'cadastral-unknown-fill', this.handleUnknownHover);
		this.map.off('mouseleave', 'cadastral-unknown-fill', this.handleUnknownLeave);
		
		this.map.off('click', 'cadastral-known-fill', this.handleKnownClick);
		this.map.off('click', 'cadastral-unknown-fill', this.handleUnknownClick);
	
	}
	setKnownFillPaint(){
		
		var a = this.lastKnownHoveredId ? [this.lastKnownHoveredId] : [];
		var b = this.lastUnknownHoveredId ? [this.lastUnknownHoveredId] : [];
		
		var activePlots = [...this.selectedKnownPlots, ...this.selectedPlots, ...b];
		
		this.map.setPaintProperty(
			'cadastral-known-fill', 
			'fill-opacity', 
			['case', 
				//['in', ['get', 'propertyid'], ["literal", this.hiddenPlots]], 0, 
				["==",['length', ["literal", [...a, ...activePlots]]], 0], parseFloat(process.env.REACT_APP_REST_OPACITY),
				['in', ['get', 'propertyid'], ["literal", [...a, ...this.selectedKnownPlots]]], parseFloat(process.env.REACT_APP_ACTIVE_OPACITY), 
				['all',
					["!=",['length', ["literal", activePlots]], 0], 
					["==",['index-of', ['get', 'propertyid'], ["literal", activePlots]], -1]
				], parseFloat(process.env.REACT_APP_DIMM_OPACITY),
				
				parseFloat(process.env.REACT_APP_DIMM_OPACITY)
			]
		);
		this.map.setPaintProperty(
			'cadastral-known-fill-line', 
			'line-opacity', 
			['case', 
				//['in', ['get', 'propertyid'], ["literal", this.hiddenPlots]], 0, 
				["==",['length', ["literal", [...a, ...activePlots]]], 0], parseFloat(process.env.REACT_APP_REST_OPACITY),
				['in', ['get', 'propertyid'], ["literal", [...a, ...this.selectedKnownPlots]]], parseFloat(process.env.REACT_APP_ACTIVE_OPACITY), 
				['all',
					["!=",['length', ["literal", activePlots]], 0], 
					["==",['index-of', ['get', 'propertyid'], ["literal", activePlots]], -1]
				], parseFloat(process.env.REACT_APP_DIMM_OPACITY),
				parseFloat(process.env.REACT_APP_DIMM_OPACITY)
			]
		);
		this.map.setPaintProperty(
			'cadastral-known-fill-line', 
			'line-width', 
			['case', 
				['in', ['get', 'propertyid'], ["literal", [...a, ...this.selectedKnownPlots]]], parseFloat(process.env.REACT_APP_ACTIVE_LINE_WIDTH), 
				parseFloat(process.env.REACT_APP_REST_LINE_WIDTH)
			]
		);
		this.map.setPaintProperty(
			'cadastral-known-fill-line', 
			'line-color', 
			['case', 
				['in', ['get', 'propertyid'], ["literal", [...a, ...this.selectedKnownPlots]]], 
								[
							        'case',                             // Start a conditional expression
							        ['has', 'color'],                   // Check if the 'color' property exists
							        ['get', 'color'],                   // If true, use the color from the data
							        '#FFFFFF'                           // Otherwise, use white color
							    ], 
				'#000000'
			]
		);
	}
	setUnknownFillPaint(){
		
		var a = this.lastUnknownHoveredId ? [this.lastUnknownHoveredId] : [];
		var b = this.lastKnownHoveredId ? [this.lastKnownHoveredId] : []
		
		var activePlots = [...this.selectedKnownPlots, ...this.selectedPlots, ...b];

		//setfilter and setpaintproperty is just to slow

		this.map.setPaintProperty(
			'cadastral-unknown-fill', 
			'fill-opacity', 
			['case',
				['==', ['get', 'known_owner'], 1], 0,
				["==",['length', ["literal", [...a, ...activePlots]]], 0], parseFloat(process.env.REACT_APP_REST_OPACITY),
				['in', ['get', 'vindrid'], ["literal", [...a, ...this.selectedPlots]]], parseFloat(process.env.REACT_APP_ACTIVE_OPACITY), 
				['all',
					["!=",['length', ["literal", [...a, ...activePlots]]], 0], 
					["==",['index-of', ['get', 'vindrid'], ["literal", activePlots]], -1]
				], parseFloat(process.env.REACT_APP_DIMM_OPACITY),
				parseFloat(process.env.REACT_APP_REST_OPACITY)
			]
		);
		
	
	}
	fetchOwner(row, e){
		//row is of type owner
		
		e.target.closest(".context-menu").classList.add("loading");
		
		super.fetchOwner([row.vindrid], this.getCountry())
			.then((result)=>{
				
				if(!result.data){
					e.target.closest(".context-menu").classList.replace("loading","error");
				}
				else{

					e.target.closest(".context-menu").classList.remove("loading");
					if(result.data[row.vindrid])
						this.handleFetchOwner(result.data[row.vindrid], row.vindrid);

				}
				
			
			});
		
		
		
		
	}
	handleFetchOwner = (owners, vindrId) => {
		
		owners = !Array.isArray(owners) ? [owners] : owners;
		
	
		const {QN, getters, setters} = this.context;
		
		var idx = this.data.findIndex((o)=>{return o.vindrid == vindrId});

		if(idx > -1 ) {
			
			var model = structuredClone(this.data[idx]);

			var listEntries = owners.map((i)=>{

				var item = structuredClone(model);

				item.fullName		= i.fullName ? i.fullName : (i.companyName ? i.companyName : i.firstName+' '+i.lastName);
				item.color			= i.color ? i.color : process.env.REACT_APP_PLOT_NO_OWNER_COLOR;
				item.id				= vindrId;
				item.vindrid		= vindrId;
				item.unknown		= false;
				return item;
			});			
			
			Array.prototype.splice.apply(this.data, [...[idx, 1], ...listEntries]);
			
		}
		if(getters.land && getters.land.properties.vindrid == vindrId){

			var plot = JSON.parse(JSON.stringify(getters.land));

			plot.properties.color = owners[0].color;
			plot.properties.ownerid = owners.map((o)=>{
				o.fullName		= o.fullName ? o.fullName : (o.companyName ? o.companyName : o.firstName+' '+o.lastName);
				return o;
			});

			setters.setLand(plot);


		}
		//update color in the map
		
		owners.forEach((i)=>{
			QN.current.show((i.fullName ? i.fullName : (i.companyName ? i.companyName : i.firstName+' '+i.lastName))+" was assigned as owner to property "+vindrId);
		});

		this.setColor(vindrId, owners[0].color);

		

		this.reload = true;
		this.refresh(Math.random());
	}
	handleSelectOwner(owner, vindrId){
		
		
		
		atlasApi.updatePropertyOwner({propertyId:vindrId, projectId:this.tc.scenario.projectid, scenarioId:this.tc.scenario.scenario_id}, owner.id).then((res)=>{
			if(res.landowner && res.landowner.id){
				this.handleFetchOwner([res.landowner], vindrId);
				
			}
			this.closeAssociateDialog();
		})
		
	}
	handleDissassociate = (vindrId, owner) => {
		
		const {QN, getters, setters} = this.context;
		
		var idx = this.data.findIndex((o)=>{return o.vindrid == vindrId});
		
		if(idx > -1 ) {
			
			delete this.data[idx].landownerid;
			this.data[idx].fullName = "(Unknown)"
			delete this.data[idx].color;
			this.data[idx].unknown =  true;
			
			this.reload = true;
			this.refresh(Math.random());
			
		}
		if(getters.land && getters.land.properties.vindrid == vindrId){

			var plot = JSON.parse(JSON.stringify(getters.land));

			plot.properties.ownerid = plot.properties.ownerid.filter((o)=>{
				if(Number.isInteger(o) && o != owner.id)
					return true;
				else if(o.landownerid && o.landownerid != owner.id)
					return true;
				
				return false;
			});
			
			if(!plot.properties.ownerid.length){
				plot.properties.color = process.env.REACT_APP_PLOT_NO_OWNER_COLOR;
				
				this.unsetColor(vindrId)
			}
			
			setters.setLand(plot);

		}
	}
	normalizeUser(row){
	
		if(row.firstName)
			return row;
	
		return {
			"type": row.type,
			"color": row.color,
			"city": row.city,
			"companyName": row.company_name,
			"country": row.country,
			"dialogs": [],
			"email": row.email,
			"firstName": row.first_name,
			"fullName": row.fullName ? row.fullName : (row.companyName ? row.companyName : row.firstName+' '+row.lastName),
			"id": row.landownerid,
			"identifier": row.landownerid,
			"lastName": row.last_name,
			"phone": row.phone,
			"properties": [],
			"street": row.street,
			"totalArea": 0,
			"turbines": 0,
			"zipcode": ""
		};
		
		
		
	}
	/*
	 the tiles server is using the production database therefor changes to the user will not be seen in the map
	 */
	
	handleEditOwner(owner){
		this.setEditOwner({open:true, owner:this.normalizeUser(owner), onSave:this.reloadLayers});
	}
	handleCreateOwner(owner, row){
		this.setEditOwner({open:true, owner:owner, onSave:(owner)=>{this.handleSelectOwner(owner, row.id)}});
	}

	handleNoResults(needle, row){
		
		var swap = needle.split(" ");
		var temp = {firstName:swap.slice(0, -1).join(" "), lastName:swap[swap.length-1]};
		
		
		return <Button className="btn-land-actions" onClick={(e)=>{this.handleCreateOwner(temp, row);}}><Plus size={16} /> Create new owner "{needle}"</Button>
	}
	openAssociateDialog(row){
		
		const {dialogs} = this.context;
		
		
		dialogs.setAssocDialog({
			open:true,
			onNoResults: (needle)=>{return this.handleNoResults(needle, row);},
			onSelect: (owner)=>{this.handleSelectOwner(owner, row.vindrid);}
			
		});
		
		
	}
	closeAssociateDialog(){
		const {dialogs} = this.context;
		
		
		dialogs.setAssocDialog({
			open:false,
			onNoResults: (needle)=>{},
			onSelect: (owner)=>{}
		});
		
	}
	openChangeColorDialog(row){
		
		
		var owner = {...row};
		owner.id = owner.landownerid ?? owner.id;
		
		const {dialogs} = this.context;
		
		
		dialogs.setChangeColor({
			open:true,
			onSave: (data)=>{
				const {getters, setters} = this.context;
				
				if(getters.owner && getters.owner.landownerid == data.id){
					var owner = JSON.parse(JSON.stringify(getters.owner));
					
					owner.color = data.color;
					setters.setOwner(owner);
					
				}
				
				this.reloadLayers();
				
				
			},
			owner: owner
		});
		
		
	}
	
	contextMenu(){
		return [{
			name:'',
			cell: row => (<div className="context-menu" data-tag="allowRowEvents">
						<Dropdown className="minimal">
							<Dropdown.Toggle className="p-0 px-1" variant="default">
								<DotsThreeVertical size={16} />
							</Dropdown.Toggle>
							<Dropdown.Menu>
								{row.unknown &&
									<>
										{Country.canFetchOwners(this.getCountry()) &&
											<Dropdown.Item href="#" onClick={(e)=>{this.fetchOwner(row, e); }}><Book  weight="bold" size={16} /> Fetch landowner {this.fetchOwnersCost(1)}</Dropdown.Item>
										}
										<Dropdown.Item href="#" onClick={(e)=>{this.openAssociateDialog(row); }}><PencilLine  weight="bold"  size={16} /> Assign manually</Dropdown.Item>
									</>
								}
								{!row.unknown &&
									<>
										<Dropdown.Item href="#" onClick={(e)=>{this.openChangeColorDialog(row); }}><Palette   weight="bold" size={16} /> Change owner color</Dropdown.Item>
										<Dropdown.Item href="#" onClick={(e)=>{this.handleEditOwner(row); }}><PencilLine weight="bold" size={16} /> Edit owner details</Dropdown.Item>
									</>
								}
								<Dropdown.Item href="#" onClick={(e)=>{this.handleZoomToFit(row)}}><Crosshair  weight="bold" size={16} /> Zoom to fit</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
						<CircleNotch className="spin" size={16} />
						<Warning className="text-danger" size={16} />
			</div>),
			style:{
				maxWidth:"20px !important"
			}
		}];
		
	}
	propertyAttributes(land, landOwners){
		const {getters} = this.context;
		var stats = [land.properties.totalarea,0];
		if(landOwners.length){

			const lId = landOwners[0];

			const o = this.tc.scenario.landowners.find((ow)=>{return ow.id == lId});

			if(o){
				const prop = o.properties.find((p)=>{return p.id == land.properties.vindrid});
				if(prop && prop.area && prop.areaPercentage)
					stats = [prop.area, prop.areaPercentage];
			}
		}
		
		return (
			<>
				{!!land.properties.vindrid &&
				<Row className="basic-info mb-2">
					<Col xs="12">
						<i className="ri-circle-fill mr-2" style={{color:land.properties.color}}></i>

						<button className="btn btn-text p-0">
							<b>ID: </b>
							{land.properties.vindrid }
						</button>
					</Col>
				</Row>
				}


				{landOwners.length>1 &&
				<Row className="basic-info mb-2">
					<Col xs="12">
						<Info className="text-warning mr-2" size={16} />
						This property has multiple owners
					</Col>
				</Row>
				}

				{!!land.properties.name && 
				<Row className="basic-info mb-2">
					<Col xs="12">
						<Building size={16} />
						<b>Name: </b>
						{land.properties.name}
					</Col>
				</Row>
				}
				<Row className="basic-info mb-2">
					<Col xs="12">
						<Pentagon size={16} />
						<b>Total property size: </b>
						{formatArea(stats[0], getters.user)}
					</Col>
				</Row>
				{!!stats[1] &&
				<Row className="basic-info mb-2">
					<Col xs="12">
						<Polygon size={16} />
						<b>Area: </b>
						{stats[1].toLocaleString()}%
					</Col>
				</Row>
				}
			</>
		);
	}
	
}

export default WorkmodeAll;